import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasMoved.meta';

export type UseTrackCanvasMovedParams = {
  canvas_id: string;
  original_location?: string;
  new_location?: string;
};

export const useTrackCanvasMoved = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasMoved = useCallback(
    (params: UseTrackCanvasMovedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasMoved };
};
